/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'gatsby';
import DisqusWrapper from '../DisqusWrapper';

import { StyledDetailsShort } from './DetailsShortStyles';

const renderTag = tagObj =>
  tagObj && tagObj.length >= 1
    ? tagObj.map((tag, index) => {
        const { tag1 } = tag;
        return (
          <Link to={`blog/tag/${tag1._meta.uid}`} className="tag" key={tag1.tag}>
            {tag1.tag}
            {tagObj.length > 1 && index < tagObj.length - 1 ? ',' : ' '}
          </Link>
        );
      })
    : null;

const Details = (tagObj, blog_post_date, extraclass, blog_headline, id) => (
  <StyledDetailsShort className={extraclass}>
    Posted
    {blog_post_date ? ' ' : ''} {blog_post_date}
    &nbsp;
    {tagObj && tagObj.length >= 1 ? ' in ' : ''} {renderTag(tagObj)}
    {/* •{' '} */}
    {/* {DisqusWrapper(blog_headline, id, 'commentCount')} */}
  </StyledDetailsShort>
);
export default Details;
